export enum VatReleaseReasonSource {
    Act = "Act",
    Directive = "Directive",
    Other = "Other"
}